import {Configuration, ConfigurationParameters} from '../../../generated-api';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    //Set ACCESS TOKEN Here!!! If and when it will be needed.
  };
  return new Configuration(params);
}
